export type NavbarLinkKey =
    | 'familia'
    | 'productos'
    | 'envios'
    | 'locales';

export interface NavbarLinkConfig {
    key: NavbarLinkKey;
    visible: boolean;
    orden: number;
}

export const NAVBAR_LINKS: Record<NavbarLinkKey, { label: string; to: string }> = {
    familia: { label: 'Familia', to: '/familia' },
    productos: { label: 'Productos', to: '/productos' },
    envios: { label: 'Envío a domicilio', to: '/envios' },
    locales: { label: 'Locales', to: '/locales' }
};

export const DEFAULT_NAVBAR_CONFIG: NavbarLinkConfig[] =
    (Object.keys(NAVBAR_LINKS) as NavbarLinkKey[]).map((key, orden) => ({
        key,
        visible: true,
        orden
    }));

export const normalizeNavbarConfig = (links: unknown): NavbarLinkConfig[] => {
    if (!Array.isArray(links)) return DEFAULT_NAVBAR_CONFIG;

    const received = new Map<NavbarLinkKey, NavbarLinkConfig>();
    links.forEach((link) => {
        if (!link || typeof link !== 'object') return;
        const candidate = link as Partial<NavbarLinkConfig>;
        if (!candidate.key || !(candidate.key in NAVBAR_LINKS)) return;
        received.set(candidate.key, {
            key: candidate.key,
            visible: candidate.visible !== false,
            orden: Number.isFinite(Number(candidate.orden)) ? Number(candidate.orden) : received.size
        });
    });

    return DEFAULT_NAVBAR_CONFIG
        .map(defaultLink => received.get(defaultLink.key) || defaultLink)
        .sort((a, b) => a.orden - b.orden);
};
